









import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import UserSetting from "@/components/templates/UserSetting/index.vue";
import { Auth } from "aws-amplify";
import snackbar from "@/shared/snackbar";

@Component({
  components: { UserSetting },
})
export default class UserSettingView extends Vue {
  private userInfo = {};
  private changeEmailRequestIsDone = false;

  private mounted() {
    Auth.currentAuthenticatedUser()
    .then((user) => {
      console.log(user);
      this.userInfo = user;
    })
    .catch((err) => {
      console.log(err);
    });
  }

  private handleOnChangePassword(passwordInfo: any) {
    this.$store.dispatch("app/startRequest");
    this.$store.dispatch("auth/changePassword", passwordInfo)
    .then((user) => {
      this.$store.dispatch("app/endRequest");
      console.log(user);
      snackbar.success(this, { message: "パスワードを変更しました。"});
    })
    .catch((err) => {
      this.$store.dispatch("app/endRequest");
      console.log(err);
      snackbar.error(this, { message: `パスワードの変更に失敗しました。: ${err}`});
    });
  }

  private async handleChangeEmail(email: string) {
    try {
      this.$store.dispatch("app/startRequest");
      const result = await this.$store.dispatch("auth/changeEmail", email);
      this.changeEmailRequestIsDone = true;
      this.$store.dispatch("app/endRequest");
      snackbar.success(this, { message: `新しく登録されたメールアドレスに宛に認証コードを送信しました。` });
    } catch (err) {
      this.$store.dispatch("app/endRequest");
      snackbar.error(this, { message: `エラーが発生しました: ${err}`});
    }
  }

  private async handleVerifyEmail(code: string) {
    try {
      this.$store.dispatch("app/startRequest");
      const result = await this.$store.dispatch("auth/verifyEmail", code);
      this.changeEmailRequestIsDone = false;
      this.$store.dispatch("app/endRequest");
      snackbar.success(this, { message: `メールアドレスの検証に成功しました。` });
    } catch (err) {
      this.$store.dispatch("app/endRequest");
      snackbar.error(this, { message: `エラーが発生しました: ${err.message}`});
    }
  }
}
